import { render, staticRenderFns } from "./graphPatrimoniesSetup.vue?vue&type=template&id=8af817f8&"
import script from "./graphPatrimoniesSetup.vue?vue&type=script&lang=js&"
export * from "./graphPatrimoniesSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports